import { useQuery } from "@tanstack/react-query";
import { getUnitDocuments } from "../sevices/documentApi";

/**
 * React Query hook for fetching documents for a specific unit
 * @param {string} unitId - ID of the unit to fetch documents for
 * @param {Object} filters - Optional filters and pagination parameters
 * @param {string} key - Optional custom query key (defaults to "unitDocuments")
 * @returns {Object} - Query result with documents data and status
 */
export function useUnitDocuments(unitId, filters = {}, key = "unitDocuments") {
  const { isLoading, data, error, isError, refetch, isRefetching } = useQuery({
    queryKey: [`${key}`, filters],
    queryFn: () => getUnitDocuments(unitId, filters),
    enabled: !!unitId, // Only run the query if unitId is provided
  });

  // Format the response data to match the expected structure
  const responseData =
    data?.data?.data || [];


  return {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    isRefetching,
  };
}
